import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    updateButton: {
      textTransform: 'inherit',
      textAlign: 'right',
      fontSize: '12px',
      fontWeight: 500,
    },

    logoActions: {
      textAlign: 'right',
      '& > *': {
        marginLeft: theme.spacing(0.25),
      },
    },

    capitalize: {
      textTransform: 'capitalize',
    },

    textRight: {
      textAlign: 'right',
    },

    mt10: {
      marginTop: 10,
    },

    mt5: {
      marginTop: 5,
    },

    cardContentPadding: {
      padding: '24px 24px;',
    },

    detaileDivider: {
      margin: '15px auto',
      width: '100%',
    },

    infoList: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      width: '100%',
      alignItems: 'flex-start',
    },

    infoItem: {
      width: '100%',
      padding: '0 0 0 0',
      borderBottom: '0 !important',
    },

    imagePlaceHolder: {
      marginTop: '27px',
      minWidth: '100%',
      maxHeight: '100px',
      height: '100px',
      backgroundColor: '#E4E4E4',
    },

    image: {
      width: '100%',
      margin: '0 auto',
      height: '100%',
    },
  };
});

const customCardStyles = makeStyles((theme) => {
  return {
    root: {
      padding: 0,
      paddingBottom: '0 !important',
      borderBottom: '0 !important',
    },
  };
});

const listStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      textAlign: 'left',
      paddingLeft: '4px',
    },

    primary: {
      fontSize: 13,
      fontWeight: 500,
      color: '#2C2C2E',
      textAlign: 'left',
      wordBreak: 'break-word',
    },

    secondary: {
      fontSize: '13px',
      color: '#4D4F5C',
      fontWeight: 300,
      wordBreak: 'break-word',
      maxWidth: '70%',
      marginLeft: '8px',
    },
  };
});

export { useStyles, listStyles, customCardStyles };
